import { RouteHandler } from 'wee-routes';
import Vue from 'vue';
import $ from 'wee-dom';
import simpleSearchOptions from './index.vue';

// Create component constructor
export const SimpleSearch = Vue.extend(simpleSearchOptions);

// Register and mount component
export default new RouteHandler({
    init() {
        const $simpleSearches = $(':simpleSearch');

        if ($simpleSearches.length) {
            $simpleSearches.each((el) => {
                const $el = $(el);
                const { type, label, placeholder } = $el.data();

                new SimpleSearch({
                    data: {
                        type,
                        label,
                        placeholder,
                    },
                }).$mount(el);
            });
        }
    },
});
